module.exports = __webpack_public_path__ + "img/Status_Disabled.0e8e53e4.svg";